export const unsupportedSwapTokens = [
  '0xD4329C92abEb03Bbc9f99DA3d38Fb65a10255a8e',
  '0x0000000000000000000000000000000000000000',
]
